import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";

const useDeleteException = () => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();
	const destroy = async (id) => {
		const instance = await InitApi({ accessToken });
		const response = await instance.delete(`/reported-exceptions/${id}`);
		await queryClient.invalidateQueries("exceptions");
		return response?.data;
	};

	return useMutation(destroy, {
		onSuccess: async (body) => {
			toast.success(body.message);
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useDeleteException;
